import { TwilioPhoneNumber } from '@/types/generated/graphql';

export const PurchaseNumberKey = 'purchaseNumber';
export type PurchaseNumberDetail = TwilioPhoneNumber;
